import { FC } from 'react';
import { Box, Grid, GridItem, Spacer } from '@chakra-ui/react';
import { ListPageTitle } from 'components/atoms/ListPageTitle';
import { SearchFields } from 'components/molecules/SearchFields';
import { RegistrationButton } from 'components/atoms/RegistrationButton';

type Props = {
  searchValue: string;
  handleSearchValueChange: (value: string) => void;
  handleClickRegistration: () => void;
};

export const CrawlerHeaderView: FC<Props> = ({
  searchValue,
  handleSearchValueChange,
  handleClickRegistration,
}) => (
  <Box m="40px 5px 0 5px">
    <Grid
      templateColumns="1fr 2fr 1fr 1fr"
      gap={0}
      justifyItems="start"
      alignItems="center"
      h="40px"
    >
      <GridItem>
        <ListPageTitle title="クローラー管理" />
      </GridItem>
      <GridItem w="100%">
        <SearchFields
          value={searchValue}
          handleChange={handleSearchValueChange}
        />
      </GridItem>
      <GridItem>
        <Spacer />
      </GridItem>
      <GridItem justifySelf="right">
        <RegistrationButton
          label="クローラー登録"
          width="160px"
          onClick={handleClickRegistration}
        />
      </GridItem>
    </Grid>
  </Box>
);
